import usePackage from '@thd-nucleus/data-sources/hooks/usePackage';
import { useStoreId } from '@thd-nucleus/experience-context';
import { handleErrors, HTTP_CODE } from '../../utils/redirector-utils';

export function getPackageRules({ packageId }) {
  let shouldRedirect = false;
  let httpCode = HTTP_CODE.OK;
  let redirectPath;
  const storeId = useStoreId();

  if (!/^package_/.test(packageId)) {
    return {
      shouldRedirect: false,
      isErrorStatus: true,
      httpCode: HTTP_CODE.NOT_FOUND
    };
  }

  const { data, loading, error } = usePackage({
    packageId,
    storeId,
    domains: ['packages'],
    batchDomains: false,
    ssr: true,
    productDomains: [
      'identifiers',
      'info',
      'details',
      'media',
      'badges',
      'reviews',
      'pricing',
      'keyProductFeatures'
    ]
  });

  if (!data && loading) return { loading };

  const errors = handleErrors(error);

  if (errors) {
    return errors;
  }

  if (
    (packageId && !data?.packages)
    || data?.packages.length === 0
    || !data?.packages[0].products
    || !data?.packages[0].metadata
    || (!data && !error && !packageId)
  ) {
    return {
      shouldRedirect: false,
      isErrorStatus: true,
      httpCode: HTTP_CODE.NOT_FOUND
    };
  }

  return {
    shouldRedirect,
    redirectPath,
    httpCode
  };
}
